define('bindingHandlers/validation/formControl',[
    'jquery',
    'lib/knockout',
    'lib/lodash4'
], function ($, ko, _) {
    'use strict';

    /**
     * Usage Examples
     *
     * <input type="text" data-bind="formControl: myObservable"/>
     *
     * FormControl
     *
     * formControl elements must be a DOM descendant of an element bound with formGroup. There
     * can only be one formControl per formGroup.
     *
     * The behavior of formControl is that upon typing in an invalid field, the error
     * will immediately be cleared until validation re-occurs. FormControl also facilitates
     * the form binding behavior of focusing the first invalid control on a form.
     */
    ko.bindingHandlers.formControl = {
        init: function (element, valueAccessor, allBindings) {
            var observable = valueAccessor();

            // Set element class.
            $(element).addClass('form-control');

            // The form control will register with a parent form.
            var $form = $(element).closest('.pc-form, form');
            if ($form.length === 0) {
                throw new Error('Detected a formControl outside of a form!');
            }

            var getFormGroup = function () {
                var foundFormGroup;
                var formGroupList = ko.utils.domData.get($form[0], 'formGroupList');
                _.forEach(formGroupList, function (formGroup) {
                    if (formGroup.observable === observable) {
                        if (foundFormGroup) {
                            throw new Error('Form control observable matched multiple form groups.');
                        }
                        foundFormGroup = formGroup;
                    }
                });
                return foundFormGroup;
            };

            var foundFormGroup = getFormGroup();
            if (!foundFormGroup) {
                throw new Error('Could not match a form control to its form group.');
            }
            else {
                foundFormGroup.controlElement = element;
            }

            // When a form control is focused, it should stop displaying errors until the user takes another action.
            $(element).on('focus.form-group', function () {
                $(element).one('keypress', function () {
                    if (foundFormGroup.observable.isModified && foundFormGroup.observable.isModified()) {
                        foundFormGroup.observable.isModified(false);
                    }
                });
            });

            // Delegate to the value binding.
            ko.bindingHandlers.value.init.call(this, element, valueAccessor, allBindings);

            // Cleanup
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                var foundFormGroup = getFormGroup();
                if (foundFormGroup) {
                    foundFormGroup.controlElement = null;
                }
                $(element).off('.form-group');
            });
        },
        update: ko.bindingHandlers.value.update
    };
});

